import {
  FormField as CarrotFormField,
  Form as CarrotForm
} from '@dagens/carrot';
import { FormField } from '../fields/field';
import { Form as FormComponent } from './form';
import { FormProvider } from './provider';

export const Form = Object.assign(FormComponent, {
  Provider: FormProvider,
  Field: FormField,
  Group: CarrotFormField.Group,
  FeedbackAlert: CarrotFormField.FeedbackAlert,
  Section: CarrotForm.Section,
  Container: CarrotForm.Container
});
